<template>
  <div class="uk-margin-small-left">
    <!--изначальное состояние-->
    <button v-if="sort_by.column === value && sort_by.order === 'desc'" @click="sortBy(value, 'desc')">
      <span class="uk-icon uk-link-reset">
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon
            points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon><line
            fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line></svg>
      </span>
    </button>
    <button v-else-if="sort_by.column === value && sort_by.order === 'asc'" @click="sortBy(value, 'asc')">
      <span class="uk-icon uk-link-reset">
        <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon
            points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon><line
            fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line></svg>
      </span>
    </button>
    <!--после активации сортировки-->
    <template v-else>
      <button @click="sortBy(value, 'asc')">
        <span class="uk-icon uk-link-reset">
          <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon
              points="10.5,4 15.37,9.4 14.63,10.08 10.5,5.49 6.37,10.08 5.63,9.4"></polygon><line
              fill="none" stroke="#000" x1="10.5" y1="16" x2="10.5" y2="5"></line></svg>
        </span>
      </button>
      <button @click="sortBy(value, 'desc')">
        <span class="uk-icon uk-link-reset">
          <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><polygon
              points="10.5,16.08 5.63,10.66 6.37,10 10.5,14.58 14.63,10 15.37,10.66"></polygon><line
              fill="none" stroke="#000" x1="10.5" y1="4" x2="10.5" y2="15"></line></svg>
        </span>
      </button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    sort_by: {
      type: Object,
    },
    value: {
      type: String
    },
  },
  methods: {
    sortBy(value, order) {
      this.$emit('sortBy', {
        column: value,
        order: order
      })
    }
  }
}
</script>